export type { TooltipProps } from './Tooltip';
export { Tooltip } from './Tooltip';
export {
  hasReachedMaxCount,
  incrementTooltipVisibleCount,
} from './utils';
